import { render } from "./app-proceed-payment-method.vue?vue&type=template&id=2f5fd2d0&scoped=true"
import script from "./app-proceed-payment-method.vue?vue&type=script&lang=js"
export * from "./app-proceed-payment-method.vue?vue&type=script&lang=js"

import "./app-proceed-payment-method.vue?vue&type=style&index=0&id=2f5fd2d0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f5fd2d0"],['__file',"src/views/components/item/app-proceed-payment-method.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f5fd2d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f5fd2d0', __exports__)) {
    console.log('reload')
    api.reload('2f5fd2d0', __exports__)
  }
  
  module.hot.accept("./app-proceed-payment-method.vue?vue&type=template&id=2f5fd2d0&scoped=true", () => {
    console.log('re-render')
    api.rerender('2f5fd2d0', render)
  })

}


export default __exports__